import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {logout} from "../../actions/LoginActions";
import {jwtDecode} from "jwt-decode";
import {ACCESS_TOKEN, INITIAL_TOKEN, INITIAL_TOKEN_STAGE_CLIENT, INITIAL_TOKEN_STAGE_MFA} from "../../constants";

const useAuthRedirect = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem(ACCESS_TOKEN);

        if (token) {
            const decoded = jwtDecode(token);
            const user = decoded.IsSuperAdmin;

            if (user === 'True') {
                window.location.href = '/super-admin-management';
            } else {
                navigate('/client');
            }

            return;
        }

        if (!localStorage.getItem(INITIAL_TOKEN)) {
            dispatch(logout());
            navigate('/sign-in');
        }

        if (localStorage.getItem(INITIAL_TOKEN)) {
            const decoded = jwtDecode(localStorage.getItem(INITIAL_TOKEN));

            if (decoded?.signInStage === INITIAL_TOKEN_STAGE_MFA || decoded?.signInStage === INITIAL_TOKEN_STAGE_CLIENT) {
                dispatch(logout());
                navigate('/sign-in');
            }
        }
    }, [dispatch, navigate]);
};

export default useAuthRedirect;